import React, { useState, useEffect } from "react";
import { Form, Alert, Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import Preloader from "../../../shared/PreLoaders";
import { Authorization } from "../../../Context/Authorization";

const AddPayments = () => {
  const initialStage = {
    vfcId: "",
    accountId: "",
    voucherType: "",
    voucherNumber: "",
    partyDetails: "",
    amount: "",
    description: "",
    cashOrBank: "",
    date: "",
    type: "P",
    uploadDocument: "",
  };
  const [vfcOptions, setVfcOptions] = useState([]);
  const [accountOptions, setAccountOptions] = useState([]);
  const [voucherTypeOptions, setVoucherTypeOptions] = useState([]);
  const [formData, setFormData] = useState(initialStage);
  const [submitMessage, setSubmitMessage] = useState("");
  const [validationErrors, setValidationErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const Api = process.env.REACT_APP_API;
  const [previousTransactions, setPreviousTransactions] = useState([]);

  useEffect(() => {
    setLoading(true);
    const fetchVfcs = async () => {
      try {
        const Config = Authorization();
        const response = await axios.get(`${Api}/api/vfcs`, Config);
        const data = response.data.vfcs;

        if (Array.isArray(data)) {
          setVfcOptions(data);
        } else {
          console.error("API did not return an array", data);
        }
      } catch (error) {
        console.log("Error fetching Data", error);
      }
      setLoading(false);
    };
    fetchVfcs();
  }, []);

  useEffect(() => {
    setLoading(true);
    const fetchAccounts = async () => {
      try {
        const Config = Authorization();
        const response = await fetch(`${Api}/api/accounts`, Config);
        const data = await response.json();
        setAccountOptions(data.data);
      } catch (error) {
        console.log("Error fetching Accounts", error);
      }
      setLoading(false);
    };

    fetchAccounts();
  }, [formData.vfcId]);

  useEffect(() => {
    const fetchPreviousTransactions = async () => {
      if (!formData.vfcId) {
        console.error("VFC ID is missing, skipping API call.");
        return;
      }

      try {
        const Config = Authorization();
        const response = await axios.post(
          `${Api}/api/transactions/previous`,
          { vfcId: formData.vfcId, limit: 10 },
          { headers: { "Content-Type": "application/json", ...Config.headers } }
        );

        if (Array.isArray(response.data.data)) {
          setPreviousTransactions(
            response.data.data.filter((transaction) => transaction.type === "P")
          );
        } else {
          console.error("Unexpected API response format", response.data);
          setPreviousTransactions([]);
        }
      } catch (error) {
        console.error(
          "Error fetching previous transactions:",
          error.response?.data || error
        );
      }
    };

    fetchPreviousTransactions();
  }, [formData.vfcId]);

  useEffect(() => {
    setLoading(true);
    const fetchVoucherTypes = async () => {
      try {
        const Config = Authorization();
        const response = await fetch(
          `${Api}/api/voucher-type-mappings`,
          Config
        );
        const data = await response.json();
        setVoucherTypeOptions(data.voucherTypeMappings);
      } catch (error) {
        console.log("Error fetching Voucher Types", error);
      }
      setLoading(false);
    };
    fetchVoucherTypes();
  }, []);

  const handleChange = async (e) => {
    const { name, type, value, files } = e.target;

    if (type === "file") {
      // Store the file separately
      setFormData((prev) => ({
        ...prev,
        [name]: files[0], // Ensure uploadDocument stores the file
      }));
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.vfcId) errors.vfc = "VFC is required";
    if (!formData.accountId) errors.accountId = "Account is required";
    if (!formData.voucherType) errors.voucherType = "Voucher Head is required";
    if (!formData.voucherNumber)
      errors.voucherNumber = "Voucher Number is required";
    if (!formData.partyDetails) errors.partyDetails = "Name is required";
    if (!formData.amount) errors.amount = "Amount is required";
    if (!formData.cashOrBank) errors.cashOrBank = "Cash or Bank is required";
    if (!formData.date) errors.date = "Date is required";
    //  if (!document) errors.document = "Document is required";
    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    const formDataToSend = new FormData();

    formDataToSend.append("uploadDocument", formData.uploadDocument);

    for (const key in formData) {
      if (key !== "uploadDocument") {
        formDataToSend.append(key, formData[key]);
      }
    }

    // Send the form data to the backend
    try {
      const Config = Authorization();
      //const response = await axios.post(`${Api}/api/transactions`, formData);
      const response = await fetch(`${Api}/api/transactions`, {
        method: "POST",
        headers: {
          ...Config.headers, // Spread headers from Authorization()
        },
        body: formDataToSend,
      });
      if (response.status === 201) {
        // If the response is successful, reset form data and validation errors
        setFormData(initialStage);
        setValidationErrors({});
        setSubmitMessage("Payments submitted successfully!");
        setSubmitMessage("");
      } else {
        console.error("Error submitting form:", response.statusText);
      }
    } catch (error) {
      // Handle any errors that occur during the request
      console.error("Error submitting form:", error);
    }
  };

  return (
    <div>
      <Preloader loading={loading} />
      <div className="page-header">
        <h3 className="page-title"> Add Payments </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Add Payments
            </li>
          </ol>
        </nav>
      </div>

      <Container className="mt-5">
        {submitMessage && <Alert variant="info">{submitMessage}</Alert>}

        <Row>
          <Col md="6">
            <div className="col-md-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <p className="card-description">
                    New Payments Registration Form
                  </p>
                  <Form
                    className="addPayments"
                    onSubmit={handleSubmit}
                    noValidate
                  >
                    <Row>
                      <Col md={6}>
                        <Form.Group controlId="vfcId">
                          <Form.Label>VFC</Form.Label>
                          <div className="input-container">
                            <Form.Control
                              as="select"
                              name="vfcId"
                              value={formData.vfcId}
                              onChange={handleChange}
                              isInvalid={!!validationErrors.vfcId}
                            >
                              <option value="">Select VFC</option>
                              {vfcOptions.map((vfc) => (
                                <option key={vfc._id} value={vfc._id}>
                                  {vfc.vfcName}
                                </option>
                              ))}
                            </Form.Control>
                            <Form.Control.Feedback type="invalid">
                              {validationErrors.vfcId}
                            </Form.Control.Feedback>
                          </div>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="accountId">
                          <Form.Label>Account</Form.Label>
                          <div className="input-container">
                            <Form.Control
                              as="select"
                              name="accountId"
                              value={formData.accountId}
                              onChange={handleChange}
                              isInvalid={!!validationErrors.accountId}
                            >
                              <option value="">Select Account</option>
                              {accountOptions.map((acc) => (
                                <option key={acc._id} value={acc._id}>
                                  {acc.accountName}
                                </option>
                              ))}
                            </Form.Control>
                            <Form.Control.Feedback type="invalid">
                              {validationErrors.accountId}
                            </Form.Control.Feedback>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <Form.Group controlId="voucherType">
                          <Form.Label>Voucher Head</Form.Label>
                          <div className="input-container">
                            <Form.Control
                              as="select"
                              name="voucherType"
                              value={formData.voucherType}
                              onChange={handleChange}
                              isInvalid={!!validationErrors.voucherType}
                            >
                              <option value="">Select Voucher Head</option>
                              {voucherTypeOptions.map((voucher) => (
                                <option
                                  key={voucher.voucherType._id}
                                  value={voucher.voucherType._id}
                                >
                                  {voucher.voucherType.voucherName}
                                </option>
                              ))}
                            </Form.Control>
                            <Form.Control.Feedback type="invalid">
                              {validationErrors.voucherType}
                            </Form.Control.Feedback>
                          </div>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="voucherType">
                          <Form.Label>Voucher Number</Form.Label>
                          <div className="input-container">
                            <Form.Control
                              type="text"
                              name="voucherNumber"
                              value={formData.voucherNumber}
                              onChange={handleChange}
                              isInvalid={!!validationErrors.voucherNumber}
                            />

                            <Form.Control.Feedback type="invalid">
                              {validationErrors.voucherNumber}
                            </Form.Control.Feedback>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <Form.Group controlId="partyDetails">
                          <Form.Label>Name</Form.Label>
                          <div className="input-container">
                            <Form.Control
                              type="text"
                              name="partyDetails"
                              value={formData.partyDetails}
                              onChange={handleChange}
                              isInvalid={!!validationErrors.partyDetails}
                            />
                            <Form.Control.Feedback type="invalid">
                              {validationErrors.partyDetails}
                            </Form.Control.Feedback>
                          </div>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="amount">
                          <Form.Label>Amount</Form.Label>
                          <div className="input-container">
                            <Form.Control
                              type="number"
                              name="amount"
                              value={formData.amount}
                              onChange={handleChange}
                              isInvalid={!!validationErrors.amount}
                            />
                            <Form.Control.Feedback type="invalid">
                              {validationErrors.amount}
                            </Form.Control.Feedback>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <Form.Group controlId="description">
                          <Form.Label>Description</Form.Label>
                          <div className="input-container">
                            <Form.Control
                              type="text"
                              name="description"
                              value={formData.description}
                              onChange={handleChange}
                            />
                          </div>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="cashOrBank">
                          <Form.Label>Cash/Bank</Form.Label>
                          <div className="input-container">
                            <Form.Control
                              as="select"
                              name="cashOrBank"
                              value={formData.cashOrBank}
                              onChange={handleChange}
                              isInvalid={!!validationErrors.cashOrBank}
                            >
                              <option value="">Select</option>
                              <option value="cash">Cash</option>
                              <option value="bank">Bank</option>
                            </Form.Control>
                            <Form.Control.Feedback type="invalid">
                              {validationErrors.cashOrBank}
                            </Form.Control.Feedback>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <Form.Group controlId="date">
                          <Form.Label>Date</Form.Label>
                          <div className="input-container">
                            <Form.Control
                              type="date"
                              name="date"
                              value={formData.date}
                              onChange={handleChange}
                              isInvalid={!!validationErrors.date}
                            />
                            <Form.Control.Feedback type="invalid">
                              {validationErrors.date}
                            </Form.Control.Feedback>
                          </div>
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group controlId="uploadDocument">
                          <Form.Label>Upload Document</Form.Label>
                          <div className="input-container">
                            <Form.Control
                              type="file"
                              name="uploadDocument"
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  uploadDocument: e.target.files[0],
                                })
                              }
                              isInvalid={!!validationErrors.uploadDocument}
                            />
                            <Form.Control.Feedback type="invalid">
                              {validationErrors.uploadDocument}
                            </Form.Control.Feedback>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>

                    <button
                      type="submit"
                      className="btn btn-outline-primary btn-icon-text mt-3"
                    >
                      <i className="mdi mdi-file-check btn-icon-prepend"></i>
                      Submit
                    </button>
                    <button className="btn btn-light mt-3">Cancel</button>
                  </Form>
                </div>
              </div>
            </div>
          </Col>
          <Col md="6">
            <div className="col-md-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <p className="card-description">Previous Transactions</p>
                  <div className="row icons-list">
                    <div className="table-responsive">
                      <table striped bordered hover className="table">
                        <thead>
                          <tr className="table table-hover">
                            <th>Date</th>
                            <th>Voucher Number</th>
                            <th>Name</th>
                            <th>Amount</th>
                            <th>Description</th>
                          </tr>
                        </thead>
                        <tbody>
                          {previousTransactions.length > 0 ? (
                            previousTransactions.map((transaction, index) => (
                              <tr key={index}>
                                <td>
                                  {new Date(
                                    transaction.date
                                  ).toLocaleDateString()}
                                </td>
                                <td>{transaction.voucherNumber}</td>
                                <td>{transaction.partyDetails}</td>
                                <td>{transaction.amount}</td>
                                <td>{transaction.description}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="5" className="text-center">
                                No transactions found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AddPayments;
